  <router-outlet></router-outlet>
<app-tcc-spinner [themeColor]="'primary'" [size]="'xlarge'"></app-tcc-spinner>
 
